import { useCallback, useEffect, useState } from 'react'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table.js'

import { STORAGE_KEYS } from '@/shared/constants'
import { SetterCallback } from '@/shared/types'

const defaultSearchConfig = {
  type: 'column' as 'column' | 'row',
  value: '',
  columnTypes: [] as ColumnTypes[],
}

export function getPersistedSearchConfig(tableId: string) {
  const persistedConfig = sessionStorage.getItem(`${STORAGE_KEYS.GRID_SEARCH_CONFIG}-${tableId}`)
  if (persistedConfig) {
    return JSON.parse(persistedConfig) as typeof defaultSearchConfig
  }
  return defaultSearchConfig
}

export const useGridSearchConfig = (tableId: string) => {
  // Search Config
  const [searchConfig, setSearchConfig] = useState(getPersistedSearchConfig(tableId))

  const updateSearchConfig = useCallback(
    (cb: SetterCallback<typeof searchConfig>) => {
      setSearchConfig((prev) => {
        const newConfig = typeof cb === 'function' ? cb(prev) : cb
        sessionStorage.setItem(`${STORAGE_KEYS.GRID_SEARCH_CONFIG}-${tableId}`, JSON.stringify(newConfig))
        return newConfig
      })
    },
    [tableId]
  )

  useEffect(() => {
    setSearchConfig(getPersistedSearchConfig(tableId))
  }, [tableId])

  return {
    searchConfig,
    updateSearchConfig,
  }
}
